var i18n = {
    lang: document.documentElement.lang,
    dict: {},
    init: function () {
        var self = this;

        $.ajaxSetup({
            async: false
        });

        $.getJSON("/js/translations/" + this.lang + ".json?v=20210409", function (data) {
            self.dict = data;
        });

        $.ajaxSetup({
            async: true
        });

        return this;
    },
    _: function (string) {
        if ($.isEmptyObject(this.dict)) {
            this.init();
        }

        return this.dict[string];
    }
};

(function (jQuery) {
    jQuery.i18n = function (string) {
        return i18n._(string);
    }
}(jQuery));
